import React, { useEffect } from 'react';
import FormInput from '../Form/FormInput';
import StringSelector from '../Form/StringSelector';
import RichTextEditor from '../Form/RichTextEditor';
import { Container, Row, Col } from 'reactstrap';
import { useFormikContext } from 'formik';
import { endpoints } from '../../utils/Constants';
import { useFetchEntity } from '../../Services/fetchApi';
import { useState } from 'react';
import SelectSetting from '../Form/SelectSetting';
import LoadingAnimation from '../Form/LoadingAnimation';
import { InsertPaths } from './InsertPaths';


const StateChangeEventDetail = () => {
    const { values, setFieldValue } = useFormikContext()
    //<StringSelector id='catering' label="Catering" list={charterTypes?.catering} />
    //  <BooleanInput id='shared' label='Shared' />
    const { entityType, newState, fromState,  notificationType } = values;
    const [settings, loadingSettings, error] = useFetchEntity({ name: 'StateChangeOptions', getByStatus: () => endpoints.getStateChangeOptions });
    const [paths, loadingPaths, loadingError] = useFetchEntity({ name: 'Paths', getByStatus: () => endpoints.getAccessorsForEntity + entityType });
    const [ta, loadingTargets, loadingTargetsError] = useFetchEntity({ name: 'Targets', getByStatus: () => endpoints.getTargetsForEntity + entityType });
    const [targetAudience,setTargetAudience] = useState([])
    const [editor, setEditor] = useState();
    const isServer = notificationType === "System";
    const isRich = notificationType === "Email";
    const hideSubject = notificationType === "SMS";
    const loading = loadingSettings || loadingPaths || loadingTargets;
   
    useEffect(() => {
        if (ta) {
            setTargetAudience(ta.map((x) =>  x.name));
        }
    },[ta]
    )
   
    const insertSubject = (item) => {
        setFieldValue('subject', values.subject + '{' + item + '}');
    }
    const insertItem = (item) => {
        if (isRich) {
            editor && editor.insertHTML('{' + item + '}')
        } else {
            setFieldValue('message', values.message + '{' + item + '}');
        }
    }
    return <React.Fragment>
        <h4>{entityType + " - " + fromState + '->' + newState}</h4>
        <FormInput id='name' label='name' />
        <StringSelector id='notificationType' label="Notification Type" options={settings ? settings.notificationType : []} /> 

        <Container>
            <Row>
                <Col>
                    {loading ? <LoadingAnimation /> : null}
                    {error ? <h6>Error Loading State Change Options</h6> : null}
                    {loadingError ? <h6>Error Loading Paths</h6> : null}
                    {loadingTargetsError ? <h6>Error Loading Targets</h6> : null}
                    {isServer ? <Row >
                        <Col>
                            <StringSelector  id='serverHandler' label="Server Handler" options={settings ? settings.serverHandler : []} />
                        </Col>
                    </Row> :
                        <React.Fragment>
                            <Row>
                                <Col>
                                    {!hideSubject ? <FormInput id='subject' label='Subject' /> : null}
                                </Col>
                            </Row>
                            <Row>
                                {!hideSubject && paths ? <InsertPaths parentPath={false} path={paths} insertItem={insertSubject} /> : null}
                            </Row>
                            <Row>
                                <Col >
                                    {isRich ? <RichTextEditor setEditor={setEditor} id='message' label='Message' /> : <FormInput id='message' label='Message' />}
                                </Col>
                            </Row>
                            <Row>
                                {paths ? <InsertPaths parentPath={false} path={paths} insertItem={insertItem} /> : null}
                            </Row>
                            <Row>
                                <Col >
                                    {isRich ? <SelectSetting id="emailTemplate"label="Email Template" string endpoint={endpoints.getEmailTemplates} /> : null}
                                </Col>


                            </Row>
                            <Row>
                                <Col >
                                    {isRich ? <FormInput id="headerTitle" label="Email Header"/> : null}
                                </Col>


                            </Row>

                            
                            <Row>
                                <Col>
                                    {settings ? <StringSelector stringType id='targetAudience' label="To" list={targetAudience ? targetAudience:[]} /> : null}
                                </Col>
                            </Row>
                        </React.Fragment>}
                </Col>
            </Row>
        </Container>


    </React.Fragment>
};

export default StateChangeEventDetail;
